"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("../styles/PickerStyle");
var underscore_1 = require("underscore");
var widgets_1 = require("@tableau/widgets");
var scopedTestId = 'recipient-picker';
var AsyncPicker = /** @class */ (function (_super) {
    __extends(AsyncPicker, _super);
    function AsyncPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastIssuedRequestTimestamp = 0;
        _this.chipPickerRef = React.createRef();
        _this.state = {
            recipientsSearchList: [],
            filterValue: '',
            inflightFetchRecipientCallbacks: new Set(),
        };
        /**
         * A handler to the value add event in the chip picker. It maps to the OnRecipientAdd event to be consumed by external code
         * @param value - The recipient instance to be added
         * @param targetIndex - The index at which the recipient should be added
         */
        _this.handleValueAdd = function (value, targetIndex) {
            if (!_this.props.onRecipientAdd) {
                return;
            }
            var predicate = function (recipient) { return _this.props.recipientToStringId(recipient) === value; };
            var existingIndex = _this.props.recipients.findIndex(predicate);
            if (existingIndex < 0) {
                var recipient = _this.state.recipientsSearchList.find(predicate);
                if (recipient) {
                    _this.props.onRecipientAdd(__assign({}, recipient), targetIndex);
                }
            }
            else {
                _this.chipPickerRef.current.focusChipAtIndex(existingIndex);
            }
        };
        /**
         * A handler to the values change event in the chip picker. It maps to the OnRecipientsChange event to be consumed by external code
         * @param selectedValues - The list of values of currently selected list items
         */
        _this.handleValuesChange = function (selectedValues) {
            if (!_this.props.onRecipientsChange) {
                return;
            }
            var getter = _this.props.recipientToStringId;
            // prepare a dictionary for fast lookup
            var userMap = {};
            _this.props.recipients.forEach(function (r) { return userMap[getter(r)] = r; });
            // map selected values to users
            var selectedUsers = selectedValues.map(function (value) { return (__assign({}, userMap[value])); });
            _this.props.onRecipientsChange(selectedUsers);
        };
        /**
         * Updates the state with the new filter value and triggers the debounced search function
         * @param filter - The text typed by the user
         */
        _this.handleFilterChanged = function (filter) {
            _this.setState({ filterValue: filter.trim() }, _this.filterChangeStateChangeCallback);
        };
        /**
         * Internal callback of filter changes. Only exists to avoid passing an arrow function callback to setState
         */
        _this.filterChangeStateChangeCallback = function () {
            if (_this.props.onFilterChanged) {
                _this.props.onFilterChanged(_this.state.filterValue);
            }
            _this.debouncedSearchFunction();
        };
        /**
         * Asynchronously queries the server for a new page of recipients. Used in a debounced function
         */
        _this.fetchRecipients = function () {
            // get the current search term and timestamp
            var searchTerm = _this.state.filterValue;
            var searchTimestamp = Date.now();
            _this.lastIssuedRequestTimestamp = searchTimestamp;
            // fetch list of users. The fetch callback returns an array of promises that we should wait for
            var inflightPromise = _this.props.fetchRecipientsCallback(searchTerm);
            // While we wait, we'll make this callback "cancelable" and store it in state
            // If this component is unmounted before the promise resolves, we can reject it ourselves to prevent a memory leak.
            var inflightCanceleablePromise = _this.makeCancelable(inflightPromise);
            _this.setState(function (prevState) {
                // Add the current in-flight promise to the list of in-flight promises
                return { inflightFetchRecipientCallbacks: new Set(prevState.inflightFetchRecipientCallbacks).add(inflightCanceleablePromise) };
            }, function () {
                inflightCanceleablePromise.promise.then(function (newRecipientsList) {
                    // If this search query is slow, it's possible that the user typed more and then a second search
                    // query was issued and it has already completed. In that case, the second query had more recent
                    // results, and these results should be dropped because they are outdated.
                    if (searchTimestamp >= _this.lastIssuedRequestTimestamp) {
                        // Update the search list with the results and remove the promise from the list, as it is no longer in-flight
                        _this.setState(function (prevState) {
                            var updatedInflightCallbacks = new Set(prevState.inflightFetchRecipientCallbacks);
                            updatedInflightCallbacks.delete(inflightCanceleablePromise);
                            return {
                                recipientsSearchList: newRecipientsList,
                                inflightFetchRecipientCallbacks: updatedInflightCallbacks
                            };
                        });
                    }
                })
                    .catch();
            });
        };
        // Wrap the given promise in another promise, which we can cancel before it resolves.
        _this.makeCancelable = function (promise) {
            var hasCanceled = false;
            var wrappedPromise = new Promise(function (resolve, reject) {
                promise.then(function (val) { return hasCanceled ? reject({ isCanceled: true }) : resolve(val); }, function (error) { return hasCanceled ? reject({ isCanceled: true }) : reject(error); });
            });
            return {
                promise: wrappedPromise,
                cancel: function () {
                    hasCanceled = true;
                },
            };
        };
        _this.debouncedSearchFunction = AsyncPicker.makeDebouncedFunction(_this.fetchRecipients, _this.props.debounceTimeout);
        return _this;
    }
    AsyncPicker.prototype.render = function () {
        var _a = this.props, recipients = _a.recipients, onRecipientAdd = _a.onRecipientAdd, onRecipientsChange = _a.onRecipientsChange, onFilterChanged = _a.onFilterChanged, recipientToListItem = _a.recipientToListItem, recipientToChip = _a.recipientToChip, recipientToStringId = _a.recipientToStringId, fetchRecipientsCallback = _a.fetchRecipientsCallback, debounceTimeout = _a.debounceTimeout, testId = _a.testId, rest = __rest(_a, ["recipients", "onRecipientAdd", "onRecipientsChange", "onFilterChanged", "recipientToListItem", "recipientToChip", "recipientToStringId", "fetchRecipientsCallback", "debounceTimeout", "testId"]);
        var finalTestId = testId + "-" + scopedTestId;
        var listItems = this.state.recipientsSearchList.map(recipientToListItem);
        return React.createElement(widgets_1.ChipPicker, __assign({ listItems: listItems, style: styles.picker, testId: finalTestId, onFilterItems: this.handleFilterChanged, onValueAdd: this.handleValueAdd, onValuesChange: this.handleValuesChange, ref: this.chipPickerRef, className: finalTestId }, rest), recipients.map(recipientToChip));
    };
    AsyncPicker.prototype.componentDidMount = function () {
        this.fetchRecipients();
    };
    AsyncPicker.prototype.componentWillUnmount = function () {
        this.debouncedSearchFunction.cancel();
        this.state.inflightFetchRecipientCallbacks.forEach(function (promise) { promise.cancel(); });
    };
    AsyncPicker.makeDebouncedFunction = function (func, timeout) {
        return underscore_1.debounce(func, timeout);
    };
    AsyncPicker.defaultProps = {
        maxLines: 2,
        debounceTimeout: 200,
        label: '',
        testId: ''
    };
    return AsyncPicker;
}(React.PureComponent));
exports.AsyncPicker = AsyncPicker;
//# sourceMappingURL=AsyncPicker.js.map